import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import ClientShipCard from "./ClientShipCard";
import ServiceUpdateCard from "./ServiceUpdateCard";
import DatePicker from "react-datepicker";
import Moment from "moment";
import { getMDSearchlist } from "../Actions/MDlistingAPI";
import "react-datepicker/dist/react-datepicker.css";
import { AutoComplete } from "primereact/autocomplete";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
// import { getServiceSearchlist } from "../Actions/ServiceUpdateAPI";
import { getShipSearchlist } from "../Actions/MMPLDashboardAPI";
import { Multiselect } from "multiselect-react-dropdown";
import { getServiceTypeList } from "../Actions/CommonAPI";
import { toast } from "react-toastify";
import $ from "jquery";
import { TramRounded } from "@material-ui/icons";

const SearchItem = {
  minyear: "",
  maxyear: "",
  IsClient: false,
  shipName: "",
  category: "",
  imoNo: "",
  status: "active",
  client: "",
  serviceStatus: "",
  nextServiceDateFrom: "",
  nextServiceDateTo: "",
  pagesize: 25,
  pagenumber: 1,
  noofrecords: 2,
  ServiceTypes: [],
  showClientDetails: false,
  filterShiplist: false,
  filterclientDetails: false,
  isTotalShips: true,
  isOverdueShips: false,
  isShipsDue10: false,
  isShipsDue30: false,
  isShipsDue60: false,
  isShipsDue90: false,
};

class ServiceUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SelectedFromDate: "",
      SelectedToDate: "",
      fromDate: "",
      allShipo: 100,
      expiredShips: 99,
      expiringShips: 1000,
      toDate: "",
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: false,
      filterTitle: "Search Ships",
      type: "",
      SearchShips: {
        minyear: "",
        maxyear: "",
        IsClient: false,
        shipName: "",
        category: "",
        imoNo: "",
        status: "active",
        client: "",
        serviceStatus: "",
        nextServiceDateFrom: "",
        nextServiceDateTo: "",
        pagesize: 25,
        pagenumber: 1,
        noofrecords: 2,
        ServiceTypes: [],
        showClientDetails: false,
        filterShiplist: false,
        filterclientDetails: false,
        isTotalShips: true,
        FilterByIsInContract: "",
        isOverdueShips: false,
        isShipsDue10: false,
        isShipsDue30: false,
        isShipsDue60: false,
        isShipsDue90: false,
      },
      inContract: false,
      notInContract: false,
      isBoth: true,
      serviceType: [],
      EquipmentList: ["A_Equipment1", "B_Equipment2", "C_Equipment"],
    };
    this.multiselectRef = React.createRef()
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onRemoveChange = this.onRemoveChange.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.openFromDatePicker = this.openFromDatePicker.bind(this);
    this.openToDatePicker = this.openToDatePicker.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.SearchShips = this.SearchShips.bind(this);
    this.ClearSearchField = this.ClearSearchField.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch } = nextProps;
    if (nextProps.isMDSearch && nextProps.showSidePane) {
      prevState.SearchShips = nextProps.MDSearchData;
    }
    if (nextProps.MDDeleteSuccess && !nextProps.showSidePane) {
      prevState.SearchShips = nextProps.MDSearchData;
      dispatch(getMDSearchlist(prevState.SearchShips));
    }
    let updatedstate = {};
    const { match } = nextProps;
    const { params } = match;
    const { type } = params;
    if (prevState.type !== type) updatedstate.type = type;
    return updatedstate;
  }

  componentDidMount() {
    const { dispatch, t } = this.props;
    if (this.props.serviceSearchData) {
      this.state.SearchShips = this.props.serviceSearchData;
      this.SearchShips(this.props.serviceSearchData.pagenumber ?? 1);
    }
    else {
      this.SearchShips(1);
    }
    dispatch(getServiceTypeList());
    dispatch({ type: "SubBannerTitle", data: "Service Update" });
    let searchitem = this.state.SearchShips;
    let _this = this;
    // $(document).keypress(function (event) {
    //   var keycode = event.keyCode || event.which;
    //   if (this.verifySearchItems())
    //     // searchitem.shipName ||
    //     // searchitem.client ||
    //     // searchitem.imoNo ||
    //     // searchitem.ServiceTypes.length > 0 ||
    //     // searchitem.nextServiceDateFrom ||
    //     // searchitem.nextServiceDateTo
    //      {
    //     if (keycode === 13) {
    //       _this.SearchShips(1);
    //     }
    //   }
    // });
    this.keyPressHandler = function (event) {

      var keycode = event.keyCode || event.which;

      if (keycode === 13) {
        if (_this.verifySearchItems()) {
          _this.SearchShips(1);
        }
        else {
          toast.success(t('Toast.Success'), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    }

    $(document).keypress(this.keyPressHandler);

  }

  componentWillUnmount() {

    $(document).off("keypress", this.keyPressHandler);
  }

  // handleKeyPress = (event) => {
  //   const { SearchShips } = this.state;
  //   if (
  //     SearchShips.shipName ||
  //     SearchShips.client ||
  //     SearchShips.imoNo ||
  //     SearchShips.ServiceTypes.length > 0 ||
  //     SearchShips.nextServiceDateFrom ||
  //     SearchShips.nextServiceDateTo
  //   ) {
  //     if (event.key === "Enter") {
  //       this.SearchShips(1);
  //     }
  //   }
  // };

  SearchShips(pgno) {
    this.state.SearchShips["pagenumber"] = pgno;
    const { dispatch } = this.props;
    this.setState({ filterShiplist: true });
    dispatch({ type: "serviceSearchData", data: this.state.SearchShips });
    dispatch(getShipSearchlist(this.state.SearchShips, this.state.inContract, this.state.isBoth, true));
  }

  verifySearchItems = () => {
    let flag = true;
    const search = this.state.SearchShips;
    if (search.shipName == "" && search.ServiceTypes == "" && search.imoNo == "" && search.minyear == "" && search.maxyear == "") {
      flag = false;
    }
    return flag;
  }

  SearchShips1(pgno) {
    const { dispatch, t } = this.props;
    if (this.verifySearchItems()) {
      this.state.SearchShips["pagenumber"] = pgno;

      this.setState({ filterShiplist: true });
      dispatch({ type: "serviceSearchData", data: this.state.SearchShips });
      dispatch(getShipSearchlist(this.state.SearchShips, this.state.inContract, this.state.isBoth, true));
    }
    else {
      toast.success(t('Toast.Success'), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  SearchClientData(pgno) {
    this.state.SearchShips["pagenumber"] = pgno;
    const { dispatch } = this.props;
    this.setState({ filterclientDetails: true });
    dispatch(getMDSearchlist(this.state.SearchShips));
  }

  ClearSearchField() {
    let param = { ...SearchItem };
    // console.log(param.ServiceTypes,'types')
    // this.setState((prevState) => ({
    //   SearchShips: {
    //     ...prevState.ServiceTypes,
    //     ServiceTypes: []
    //   },

    // }))
    // const emptyList=[]
    // this.onRemoveChange(emptyList)

    if (this.multiselectRef.current) {
      this.multiselectRef.current.resetSelectedValues();
    }

    this.setState(
      {
        SearchShips: param,
        EquipmentName: "",
      },
      () => {
        this.props.dispatch({ type: "serviceSearchData", data: "" });
        this.props.dispatch(getShipSearchlist(this.state.SearchShips, this.state.inContract, this.state.isBoth, true));
      }
    );
    this.state.SelectedFromDate = null;
    this.state.SelectedToDate = null;
    // this.props.dispatch(getShipSearchlist(this.state.SearchShips));
  }

  handleFromDateChange(date) {
    this.state.SearchShips.minyear = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.state.SearchShips.nextServiceDateFrom = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedFromDate: date,
      fromDatePickerIsOpen: false,
    });
  }

  handleToDateChange(date) {
    this.state.SearchShips.maxyear = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.state.SearchShips.nextServiceDateTo = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedToDate: date,
      toDatePickerIsOpen: false,
    });
  }

  openFromDatePicker() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
    });
  }

  openToDatePicker() {
    this.setState({
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: !this.state.toDatePickerIsOpen,
    });
  }

  handleBlur() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
    });
  }

  handleRadioButtonChanges(e) {
    this.state.SearchShips[e.target.name] = this.refs.check_me.checked
      ? "asc"
      : "desc";
    this.setState({});
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.SearchShips[nodeName] = e.target.value;
    this.setState({});
  }

  handleshipName(e) {
    let nodeName = e.target.name;
    this.state.SearchShips[nodeName] = e.target.value;
    this.setState({ EquipmentName: e.target.value });
  }

  suggestMItable(event) {
    let results = this.state.EquipmentList.filter((table) => {
      return table.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
    });

    this.setState({ EquipmentList: results });
  }

  checkBoxClick(item, e) {
    let checked = [];
    checked = this.state.serviceType;
    if (e.target.checked) {
      checked.push({
        checkboxValue: item,
      });
      if (item === "Annual") {
        this.state.SearchShips.Annually = true;
      } else if (item === "Biannual") {
        this.state.SearchShips.Biannually = true;
      } else if (item === "Five yearly") {
        this.state.SearchShips.FiveYearly = true;
      } else if (item === "Ten yearly") {
        this.state.SearchShips.Tenyearly = true;
      }
    } else {
      const index = checked.findIndex((ch) => ch.checkboxValue === item);
      checked.splice(index, 1);
      if (item === "Annual") {
        this.state.SearchShips.Annually = false;
      } else if (item === "Biannual") {
        this.state.SearchShips.Biannually = false;
      } else if (item === "Five yearly") {
        this.state.SearchShips.FiveYearly = false;
      } else if (item === "Ten yearly") {
        this.state.SearchShips.Tenyearly = false;
      }
    }
    this.setState({ serviceType: checked, serviceStatus: checked });
  }

  onSelectChange(item) {
    console.log(item, 'iew')
    this.state.SearchShips.ServiceTypes = item;
    this.setState({});
  }

  onRemoveChange(item) {
    // this.state.SearchShips.ServiceTypes = item;
    // console.log(this.state.SearchShips.ServiceTypes,'try')
    // this.setState({});
    // if(item.length === 0){
    //   this.setState({
    //     SearchShips: {
    //       ...this.state.SearchShips,
    //       ServiceTypes: [],
    //     }
    //   });
    //   console.log(this.state.SearchShips.ServiceTypes,'w')
    // }
    // else{
    this.setState((prevState) => {

      const updatedServiceTypes = prevState.SearchShips.ServiceTypes.filter(
        (serviceType) => serviceType !== item
      );

      return {
        SearchShips: {
          ...prevState.SearchShips,
          ServiceTypes: updatedServiceTypes
        }
      };
    });
    // }

  }

  render() {
    const {
      t,
      showSidePane,
      arraylist,
      serviceUpdateSearchResult,
      serviceTypeList,
    } = this.props;
    console.log(serviceUpdateSearchResult);
    console.log(this.state.SearchShips.nextServiceDateFrom, 'date');


    const { showClientDetails, showshiplist, serviceType, isServiceUpdate } =
      this.state;
    return (
      <div className="full-height">
        <div className="px-4 pt-3">
          {this.state.type === "master" ? (
            <div className="row mr-3" style={{ height: "50px" }}>
              <div
                className="ml-auto m-3 nav-item-link"
                onClick={this.MDNewitemNav}
                style={{ color: "#109AFF" }}
              >
                {t('CommonText.NewItem')}
              </div>
            </div>
          ) : null}

          {showClientDetails ? (
            <div className="row">
              <div className="col-lg-12">
                <div className="panel-box">
                  <div
                    className="card MM-card-header"
                    style={{ backgroundColor: "white", border: "0px" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        {t('TopPaneContent.Client')}
                      </h5>
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div className="row">
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label">{t('ShipManagementContent.CompanyName')}</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="shipName"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.SearchShips.shipName}
                        ></input>
                      </div>
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label">{t('content.Shipname')}</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="shipName"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.SearchShips.shipName}
                        ></input>
                      </div>
                      <div
                        className={
                          showSidePane
                            ? "col-lg-6  col-sm-12 col-xs-12"
                            : "col-lg-4  col-sm-12 col-xs-12"
                        }
                      >
                        <div className="row">
                          <div className="col-sm-6">
                            <label className="form-label">{t('ContractManagementContent.StartDate')}</label>
                            <div
                              className="input-group add-on date datepicker"
                              data-date-format="yyyy-mm-dd"
                            >
                              <input
                                type="text"
                                value={this.state.SearchShips.minyear}
                                className="form-control date-picker"
                                placeholder="From Date"
                                name="fromDate"
                              ></input>
                              <DatePicker
                                selected={this.state.SelectedFromDate}
                                onChange={this.handleFromDateChange}
                                open={this.state.fromDatePickerIsOpen}
                                onClickOutside={this.handleBlur}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                className="form-control date-picker w-5 hide-date"
                              />
                              <div
                                className="input-group-btn calendar-icon"
                                onClick={this.openFromDatePicker}
                              >
                                <button className="btn btn-default">
                                  <i className="fa fa-calendar mt-1"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-6  margin">
                            <label className="form-label">{t('ContractManagementContent.ExpiryDate')}</label>
                            <div
                              className="input-group add-on date datepicker"
                              data-date-format="yyyy-mm-dd"
                            >
                              <input
                                value={this.state.SearchShips.maxyear}
                                type="text"
                                placeholder="To Date"
                                className="form-control date-picker"
                                name="toDate"
                                data-date-format="yyyy-mm-dd"
                              />
                              <DatePicker
                                selected={this.state.SelectedToDate}
                                onChange={this.handleToDateChange}
                                open={this.state.toDatePickerIsOpen}
                                onClickOutside={this.handleBlur}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                popperPlacement="top-end"
                                className="form-control date-picker w-5 hide-date"
                              />
                              <div className="input-group-btn calendar-icon">
                                <button
                                  className="btn btn-default"
                                  onClick={this.openToDatePicker}
                                >
                                  <i className="fa fa-calendar mt-1"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label">{t('DashboardShipReports.SortBy')}</label>
                        <br></br>
                        <div className="row">
                          <div
                            className={showSidePane ? "col-lg-5 " : "col-lg-6 "}
                          >
                            <select
                              className="form-control"
                              name="sortby"
                              onChange={(e) => this.handleInputChange(e)}
                              value={this.state.SearchShips.sortby}
                            >
                              <option value="shipname">{t('content.Shipname')}</option>
                              <option value="imono">{t('content.IMOno')}</option>
                              <option value="flag">{t('TopPaneContent.Flag')}</option>
                            </select>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-3 mt-2" : "col-sm-3 mt-2"
                            }
                          >
                            <input
                              type="radio"
                              name="sortorder"
                              checked={
                                this.state.SearchShips.sortorder === "asc"
                              }
                              ref="check_me"
                              onChange={this.handleRadioButtonChanges.bind(
                                this
                              )}
                            ></input>
                            <span className="ml-1">{t('DashboardShipReports.Ascending')}</span>
                          </div>
                          <div
                            className={
                              showSidePane ? "col-sm-4 mt-2" : "col-sm-3 mt-2"
                            }
                          >
                            <input
                              type="radio"
                              name="sortorder"
                              checked={
                                this.state.SearchShips.sortorder === "desc"
                              }
                              onChange={this.handleRadioButtonChanges.bind(
                                this
                              )}
                            ></input>
                            <span className="ml-1">{t('DashboardShipReports.Descending')}</span>
                          </div>
                        </div>
                      </div>
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label">
                          {t('CommonText.TotalRows')}
                        </label>
                        <br></br>
                        <select
                          className="form-control"
                          name="pagesize"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.SearchShips.pagesize}
                        >
                          <option value="10">10</option>
                          <option value="25">20</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                      <div
                        className={
                          showSidePane
                            ? "col-lg-12 mt-2"
                            : "col-lg-12 mt-2 mb-2"
                        }
                      >
                        <label className="form-label"></label>
                        <br></br>
                        <div
                          className="form-group search-btn-col"
                          style={{ textAlign: "end" }}
                        >
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.SearchClientData(1)}
                          >
                            {" "}
                            {t('content.Search')}{" "}
                          </button>

                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.ClearSearchField()}
                          >
                            {" "}
                            {t('content.Clear')}{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {arraylist && this.state.filterclientDetails ? (
                  <ClientShipCard
                    arraylist={arraylist}
                    pageSize={this.state.SearchShips.pagesize}
                    setUpdatedState={(value) => this.SearchShips(value)}
                  />
                ) : null}
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-lg-12">
                <div className="panel-box">
                  <div
                    className="card MM-card-header"
                    style={{ backgroundColor: "white", border: "0px" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        {t('ServiceUpdateContent.SearchShips')}
                      </h5>
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div className="row">
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        {/*  <label className="form-label">Ship Name</label> */}
                        <label className="form-label">{t('content.Shipname')}</label>
                        <br></br>
                        {/* <AutoComplete value={this.state.EquipmentName} onChange={(e) => this.handleshipName(e)}
                            suggestions={this.state.EquipmentList} completeMethod={this.suggestMItable.bind(this)}
                            name="tableValue" inputClassName="form-control" placeholder="Ship Name" style={{ display: 'block' }}
                            inputStyle={!showSidePane ? { borderColor: "#ced4da", height: "38px" } : { borderColor: "#ced4da", width: '270.75px', height: '38px' }} /> */}
                        <input
                          className="form-control"
                          type="text"
                          name="shipName"
                          /* placeholder="Ship Name" */
                          placeholder={t('content.Shipname')}
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.SearchShips.shipName}
                        ></input>
                      </div>

                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label">{t('content.Servicetype')}</label>
                        {/*  <label className="form-label">Service Type</label> */}
                        <Multiselect
                          options={serviceTypeList ?? []}
                          ref={this.multiselectRef}
                          showArrow={true}
                          isObject={false}
                          style={{
                            option: {
                              "margin-right": 0,
                              display: "block",
                              "font-weight": "normal",
                            },
                            chips: { "background-color": "#1a3464" },
                          }}
                          onSelect={(item) => this.onSelectChange(item)}
                          onRemove={(item) => this.onRemoveChange(item)}
                          selectedValues={this.state.SearchShips.ServiceTypes}
                          placeholder={
                            this.state.SearchShips.ServiceTypes &&
                              this.state.SearchShips.ServiceTypes.length
                              ? ""
                              : `${t('content.Select')}` /* "Select" */
                          }
                          closeIcon="cancel"
                        />
                        {/* <div className="row">
                            <div className="col-sm-12 flex">
                              <div>
                                <input type="checkbox" checked={serviceType.length !== 0 ? (serviceType.filter(e => e.checkboxValue === 'Annual').length !== 0 ? true : false) : false} onChange={this.checkBoxClick.bind(this, 'Annual')}></input>
                                <span className="ml-1">Annual</span>
                              </div>
                              <div>
                                <input type="checkbox" checked={serviceType.length !== 0 ? (serviceType.filter(e => e.checkboxValue === 'Biannual').length !== 0 ? true : false) : false} onChange={this.checkBoxClick.bind(this, 'Biannual')}></input>
                                <span className="ml-1">Biannual</span>
                              </div>
                              <div>
                                <input type="checkbox" checked={serviceType.length !== 0 ? (serviceType.filter(e => e.checkboxValue === 'Five yearly').length !== 0 ? true : false) : false} onChange={this.checkBoxClick.bind(this, 'Five yearly')}></input>
                                <span className="ml-1">Five Yearly</span>
                              </div>
                              <div>
                                <input type="checkbox" checked={serviceType.length !== 0 ? (serviceType.filter(e => e.checkboxValue === 'Ten yearly').length !== 0 ? true : false) : false} onChange={this.checkBoxClick.bind(this, 'Ten yearly')}></input>
                                <span className="ml-1">Ten Yearly</span>
                              </div>
                            </div>
                          </div> */}
                      </div>

                      <div
                        className={
                          showSidePane
                            ? "col-lg-6  col-sm-12 col-xs-12"
                            : "col-lg-4  col-sm-12 col-xs-12"
                        }
                      >
                        <div className="row">
                          <div className="col-sm-6">
                            <label className="form-label">{t('content.NextDueFrom')}</label>
                            {/*  <label className="form-label">Next Due From</label> */}
                            <br></br>
                            <div
                              className="input-group add-on date datepicker"
                              data-date-format="yyyy-mm-dd"
                            >
                              <input
                                type="text"
                                value={
                                  this.state.SearchShips.nextServiceDateFrom
                                }
                                className="form-control date-picker"
                                /*  placeholder="From Date" */
                                placeholder={t('ServiceUpdateContent.FromDate')}
                                name="fromDate"
                              ></input>
                              <DatePicker
                                selected={this.state.SelectedFromDate}
                                onChange={this.handleFromDateChange}
                                open={this.state.fromDatePickerIsOpen}
                                onClickOutside={this.handleBlur}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                className="form-control date-picker w-5 hide-date"
                              />
                              <div
                                className="input-group-btn calendar-icon"
                                onClick={this.openFromDatePicker}
                              >
                                <button className="btn btn-default">
                                  <i className="fa fa-calendar mt-1"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-6  margin">
                            <label className="form-label">{t('ServiceUpdateContent.NextDueOut')}</label>

                            {/* <label className="form-label">Next Due Out</label> */}
                            <br></br>
                            <div
                              className="input-group add-on date datepicker"
                              data-date-format="yyyy-mm-dd"
                            >
                              <input
                                value={this.state.SearchShips.nextServiceDateTo}
                                type="text"
                                /* placeholder="To Date" */
                                placeholder={t('ServiceUpdateContent.ToDate')}
                                className="form-control date-picker"
                                name="toDate"
                                data-date-format="yyyy-mm-dd"
                              />
                              <DatePicker
                                selected={this.state.SelectedToDate}
                                onChange={this.handleToDateChange}
                                open={this.state.toDatePickerIsOpen}
                                onClickOutside={this.handleBlur}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                popperPlacement="top-end"
                                className="form-control date-picker w-5 hide-date"
                              />
                              <div className="input-group-btn calendar-icon">
                                <button
                                  className="btn btn-default"
                                  onClick={this.openToDatePicker}
                                >
                                  <i className="fa fa-calendar mt-1"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        {/* <label className="form-label">IMO No</label> */}
                        <label className="form-label">{t('content.IMOno')}</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="imoNo"
                          /*   placeholder="IMO No" */
                          placeholder={t('content.IMOno')}
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.SearchShips.imoNo}
                        ></input>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-lg-6 mt-2" : "col-lg-12 mt-2 mb-2"
                        }
                      >
                        <label className="form-label"></label>
                        <br></br>
                        <div
                          className="form-group search-btn-col"
                          style={{ textAlign: "end" }}
                        >
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.SearchShips1(1)}
                          >
                            {" "}
                            {/* Search{" "} */}
                            {t('content.Search')}{" "}
                          </button>

                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.ClearSearchField()}
                          >
                            {" "}
                            {/*    Clear{" "} */}
                            {t('content.Clear')}{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {serviceUpdateSearchResult ? (
                  <ServiceUpdateCard
                    isServiceDetail={true}
                    arraylist={serviceUpdateSearchResult}
                    pageSize={serviceUpdateSearchResult.pagination.pageSize}
                    currentPage={(serviceUpdateSearchResult.pagination.currentPage - 1) * serviceUpdateSearchResult.pagination.pageSize}
                    totalRecords={
                      serviceUpdateSearchResult.pagination.totalcount
                        ? serviceUpdateSearchResult.pagination.totalcount
                        : 0
                    }
                    setUpdatedState={(value) => this.SearchShips(value)}
                  />
                ) : null}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
  MDNewitemNav = () => {
    this.props.dispatch({ type: "MD Library", data: false });
    this.props.history.push("/Home/shipManagement");
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    arraylist: state.SidePanReducer.arraylist,
    // materialDeclarationslist: state.SidePanReducer.arraylist,
    MDDeleteSuccess: state.SidePanReducer.MDDeleteSuccess,
    isMDSearch: state.SidePanReducer.isMDSearch,
    MDSearchData: state.SidePanReducer.MDSearchData,
    serviceSearchData: state.SidePanReducer.serviceSearchData,
    //By Balu Moorthi
    serviceUpdateSearchResult:
      state.ServiceUpdateReducer.serviceUpdateSearchResult,
    serviceTypeList: state.MasterScreenReducer.applicableServiceTypeInterval || [],
    // serviceTypeList: state.SidePanReducer.ServiceTypeList || {}
    // showServiceUpdatePane: state.SidePanReducer.ShowServiceUpdatePane || false
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ServiceUpdate));
/* export default connect(mapStateToProps, mapDispatchToProps)(ServiceUpdate); */
